export const GET_MERCHANTS = gql`
    query getMerchants($searchText: String, $filters: MerchantFiltersInput) {
        merchants(searchText: $searchText, filters: $filters) {
            data {
                id
                mid
                tradingName
                merchantAccountNumber
                applicationId
                merchantContactName
                topLevelPartner
                partnerName
                status
                dateAdded
                registeredAddress {
                    county
                    country
                    eircode
                    townOrCity
                    addressLine1
                    addressLine2
                }
                contactNumber
                email
            }
            total
        }
    }
`;
export const GET_MERCHANT = gql`
    query getMerchant($id: Int!) {
        merchant(id: $id) {
            applicationId
            merchantAccountNumber
        }
    }
`;

export const GET_MERCHANT_DASHBOARD = gql`
    query MerchantDashboard($id: Int!) {
        merchantDashboard(id: $id) {
            status
            phone
            mid
            location
            legalName
            tradingName
            lastName
            id
            iban
            accountNumber
            sortCode
            firstName
            email
            bic
            sageContactId
            merchantAccountNumber
            services {
                id
                createdAt
                status
                serviceType
                product
                contractExpiry
                tradingName
                promosText
                promoExpiryDate
            }
            application {
                merchantAccountNumber
                id
                merchantInformation
            }
            notes {
                id
                subject
                body
                createdAt
                createdById
                createdBy {
                    id
                    firstName
                    lastName
                }
            }
            auditLog {
                id
                activityType
                createdAt
                userId
                user {
                    id
                    firstName
                    lastName
                }
            }
            invoices {
                id
                totalInvoiceAmount
            }
            userCurrencyCode
        }
    }
`;

export const GET_DETAILED_MERCHANT_BY_ID = gql`
    query getMerchantById($id: Int!) {
        getMerchantById(id: $id) {
            id
            tradingName
            partnerName
        }
    }
`;

export const GET_MERCHANT_BY_APPLICATION_ID = gql`
    query getMerchantByApplicationId($applicationId: Int!) {
        getMerchantByApplicationId(applicationId: $applicationId) {
            id
            mid
            terminalId
        }
    }
`;

export const GET_MERCHANT_ID_BY_ACCOUNT_NUMBER = gql`
    query MerchantIdByAccountNumber($merchantAccountNumber: String!) {
        merchantByAccountNumber(merchantAccountNumber: $merchantAccountNumber) {
            id
        }
    }
`;

export const GET_TRIAL_MERCHANTS = gql`
    query getTrialMerchants($searchText: String) {
        trialMerchants(searchText: $searchText) {
            data {
                id: serviceId
                merchantAccountNumber
                merchantTradingName
                applicationId
                activationDate
                trialEndDate
                trialEndsInDays
            }
            total
        }
    }
`;

export const GET_MERCHANT_DASHBOARD_NOTES = gql`
    query MerchantDashboardNotes($id: Int!) {
        merchantDashboard(id: $id) {
            notes {
                id
                subject
                body
                createdAt
                createdBy {
                    id
                    firstName
                    lastName
                }
            }
        }
    }
`;
